
export default function InfoBox({children, onClick}) {
  return (
    <div style={styles.infoBox} onClick={onClick}>
        <span style={styles.infoLabel}>{children}</span>
    </div>
  );
}


const styles = {
    infoBox: {
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "10px",
        border: "1px solid #e0e0e0",
        height: "50px",    
        display: "inline-flex",
        alignItems: "center",
        width: "fit-content",
    },
    infoLabel: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#666"
    },
};
